/// <amd-module name="Artifacts/Nuget/components/NugetPackageOverview" />

import { getCopyInstallCommand } from "Artifacts/Nuget/helpers/InstructionsHelper";
import { INuGetProtocolMetadata } from "Artifacts/Nuget/NuGetProtocolMetadata";
import * as NugetRes from "Artifacts/Nuget/Resources";
import { PackageDeletedMessageCard } from "Artifacts/Package/components/package-details-common/PackageDeletedMessageCard";
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import * as PackageRes from "Artifacts/Package/Resources";
import { CopyableTextField } from "Artifacts/Root/protocols/components/CopyableTextField";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as RootRes from "Artifacts/Root/Resources";
import { connectToFeed } from "Artifacts/Root/routing/Constants";
import * as React from "react";
import { generatePath, useHistory } from "react-router-dom";
import * as StringUtils from "VSS/Core/Util/String";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Button } from "VSSUI/Button";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

const NugetOverview: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const history = useHistory();

  const command = getCopyInstallCommand(pkg.name, version);
  const installCmd = StringUtils.format(
    "{0} {1}",
    NugetRes.NuGet_InstallInstructions_InstallPackageCommand_Client,
    command,
  );

  // We will need this information with the version.
  const nugetMetadata: INuGetProtocolMetadata | null =
    version.protocolMetadata && version.protocolMetadata.data
      ? (version.protocolMetadata.data as INuGetProtocolMetadata)
      : null;

  return (
    <div className="package-overview-content">
      {version.isDeleted && (
        <PackageDeletedMessageCard version={version.version} packageName={pkg.name} />
      )}
      {!version.isDeleted && !version.isListed && (
        <MessageCard severity={MessageCardSeverity.Warning} className="message-card">
          <FormatComponent format={NugetRes.PackageUnlistedMessage}>
            {version.version}
            {pkg.name}
          </FormatComponent>
        </MessageCard>
      )}
      {!version.isDeleted && (
        <PackageTile title={NugetRes.NuGet_GetThisPackage}>
          <div className="package-command">
            <Button
              iconProps={{
                iconName: "PlugConnected",
              }}
              onClick={() => {
                history.push(generatePath(connectToFeed, { feedIdentifier: feed?.name }));
              }}
            >
              {RootRes.ConnectToFeedButton}
            </Button>
            <span className="install-instructions-then">
              {PackageRes.PackageDetails_InstallInstructions_then}
            </span>
            <CopyableTextField text={command}>{installCmd}</CopyableTextField>
          </div>
        </PackageTile>
      )}
      <PackageTile title={PackageRes.PackageDetails_Description}>
        <div className="package-description">{version.description}</div>
        {nugetMetadata && nugetMetadata.releaseNotes && (
          <div>
            <div className="package-group-spacer" />
            <div className="package-group-header" role="heading" aria-level={3}>
              {NugetRes.NuGetReleaseNotes_Title}
            </div>
            {nugetMetadata.releaseNotes?.split(/\r\n|\r|\n/g).map((line, index) => {
              return <div key={"ReleaseNote_Key_" + index}>{line}</div>;
            })}
          </div>
        )}
      </PackageTile>
    </div>
  );
};

export { NugetOverview };
